import dayjs from 'dayjs';
import { LocalizationProvider as LocalizationProviderMui } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/en';
import { useIntl } from 'react-intl';
import generateLocaleId from '../../helpers/generateLocaleId';

function LocalizationProvider({ children, adapterLocale = 'en' }) {
  return (
    <LocalizationProviderMui
      dateAdapter={AdapterDayjs}
      adapterLocale={adapterLocale}
      dateLibInstance={dayjs}>
      {children}
    </LocalizationProviderMui>
  );
}

export function useLocalization() {
  const { formatMessage: formatMessageIntl, ...rest } = useIntl();

  const formatMessage = (args, values, opts) => {
    return formatMessageIntl(args, values, opts);
  };
  const dynamicMessage = message => {
    return formatMessageIntl({
      id: generateLocaleId(message),
      defaultMessage: message,
    });
  };
  return { formatMessage, dynamicMessage, ...rest };
}

export default LocalizationProvider;
